import PocketBase from 'pocketbase';

const pb = new PocketBase('https://dbap.a-traq.com');

export async function loginApi(email, password) {
  try {
    const authData = await pb.collection('Contacts').authWithPassword(email, password);
    // PocketBase returns a token and model (user info)
    const token = pb.authStore.token;
    let decoded = {};
    try {
      // Decode JWT payload (base64 decode)
      const payload = token.split('.')[1];
      decoded = JSON.parse(atob(payload));
    } catch (e) {
      decoded = {};
    }
    return { token, decoded, user: authData.record };
  } catch (error) {
    return { error: error?.message || 'Invalid credentials' };
  }
} 